// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/submit-acceptance-request-schema',
  type: 'object',
  required: ['projectId', 'workItemId'],
  properties: {
    description: {
      type: 'string',
      nullable: true,
    },
    projectId: {
      type: 'string',
      format: 'uuid',
    },
    workItemId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
